class Commander {
    constructor(name, prestiges, _shortName = undefined) {
        this._isAvailable = true;
        this.name = name;
        this.prestiges = prestiges;
        this._shortName = _shortName !== null && _shortName !== void 0 ? _shortName : name;
        this._isAvailable = this.getInitialAvail();
    }
    get isAvailable() {
        return this._isAvailable;
    }
    set isAvailable(value) {
        localStorage.setItem(this.name, String(value));
        this._isAvailable = value;
    }
    get suggestedPrestige() {
        return this.getRandomPrestige();
    }
    getLinkToSC2Coop() {
        return `https://starcraft2coop.com/commanders/${this._shortName.toLowerCase()}#buildOrder`;
    }
    reset() {
        this._isAvailable = true;
    }
    getInitialAvail() {
        const maybeAvail = localStorage.getItem(this.name);
        if (maybeAvail !== null) {
            return maybeAvail === "true";
        }
        else {
            return this._isAvailable;
        }
    }
    getRandomPrestige() {
        const availablePrestiges = this.prestiges.filter(prestige => prestige.isAvailable);
        const idx = Math.floor(Math.random() * availablePrestiges.length);
        return availablePrestiges[idx];
    }
}
export default Commander;
